<div class="p-2 pt-3 p-lg-5 pt-md-4 mb-3 h-100">

  <div class="container">

    <div class="my-3 mt-0 p-3 pt-0 background-box-opaque-rounded shadow">

      <div class="registration-page-container">

        <div class="step-page-container">

          <!--<div [ngClass]="{'d-none':!isLoading}"
          class="text-center mt-4">
          <span class="fa fa-spinner spinner-splash"></span>
        </div>-->
        <div [ngClass]="{'d-none':isLoading()}"
          class="fw-bold text-site-secondary text-uppercase fs-2 mt-2 text-center">
          Complete Registration
        </div>

        @if (profileContact) {
          <div class="mb-4 text-center">
            <p class="fs-4 text-center">
              Welcome, <em>{{profileContact.firstName}} {{profileContact.lastName}}</em>.
            </p>
            <small>
              If you are NOT <em>{{profileContact.firstName}}</em>,
              <span class="text-decoration-underline fw-bold text-site-primary pointable" (click)="logout()">click/tap here to sign-up/sign-in</span>.
              <p>Otherwise, click/tap the button (below) to proceed.</p>
            </small>
          </div>
        }

        <div [ngClass]="{'d-none':isLoading()}" class="registration-step">

          <fieldset id="account-profile"
            class="mt-2">
            <legend class="text-center">Enter the school information below for the student that will be using this product</legend>

            <form [formGroup]="profileSubmissionForm"
              (ngSubmit)="competeRegistration()"
              autocomplete="off" novalidate>

              <div class="row mt-4">

                <div class="col-lg-4">

                  <div class="form-group"
                    [ngClass]="{'error': dateOfBirthPicker.invalid && (dateOfBirthPicker.dirty || dateOfBirthPicker.touched || mouseoverProfileSubmissionSubmit)}">
                    <span class="fake-label">Birth Date <small class="text-danger ps-2">(optional)</small></span>
                    <div class="input-group">
                      <input formControlName="dateOfBirthPicker"
                        #dateOfBirthInput="bsDatepicker"
                        type="text"
                        class="form-control"
                        container=""
                        bsDatepicker
                        [bsConfig]="datePickerBaseConfig"
                        [minDate]="dateOfBirthMinDate"
                        [maxDate]="dateOfBirthMaxDate"><!--(bsValueChange)="onItemTextTypeDateSelection(true, $event)"-->
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary"
                            type="button"
                            (click)="dateOfBirthInput.toggle()">
                            <i class="fas fa-calendar-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-lg-8">

                    <span class="fake-label">Which <span class="d-none d-md-inline-block">best</span> describes you this next school year?</span>
                    @if (educationLevelSelect.invalid && (educationLevelSelect.dirty || educationLevelSelect.touched || mouseoverProfileSubmissionSubmit)) {
                      <em class="error-msg">
                        Required
                      </em>
                    }
                    <ng-select formControlName="educationLevelSelect"
                      [items]="educationLevels"
                      bindLabel="description"
                      [clearable]="false"
                      appendTo="body">
                    </ng-select>

                  </div>

                </div>

                <div class="row mt-4">

                  <div class="col-lg-4">

                    <div class="well mt-2">
                      <label for="institutionTypeSelectFieldName" class="form-label">School Type</label>
                      @if (!institutionTypeSelect && mouseoverProfileSubmissionSubmit) {
                        <em
                          class="error-msg float-none">
                          Required
                        </em>
                      }
                      <div class="row well" style="margin: 0 10px 10px;">
                        @for (institutionType of institutionTypes; track institutionType) {
                          <span class="d-inline-block mt-2">
                            <span class="d-block pretty p-default p-round">
                              <input type="radio"
                                [formControlName]="institutionTypeSelectFieldName"
                                [value]="institutionType.code"
                                (change)="institutionTypeSelect = institutionType"
                                required />
                                <span class="d-block state p-success-o">
                                  <label>{{institutionType.description}}</label>
                                </span>
                              </span>
                            </span>
                          }
                        </div>
                      </div>

                    </div>

                    <div class="col d-flex justify-content-center align-items-center">

                      <span (mouseenter)="mouseoverProfileSubmissionSubmit=true" (mouseleave)="mouseoverProfileSubmissionSubmit=false">
                        <app-button [buttonConfig]="{textChange: ['Register']}"
                          [isLoading]="isSubmitting()"
                          [disabled]="isSubmitting()"
                        (textBtnClickEmt)="competeRegistration()"></app-button>
                      </span>

                    </div>

                  </div>

                </form>

              </fieldset>

              @if (errorMessage) {
                <div class="alert alert-danger mt-4" role="alert">
                  Error Occurred: {{errorMessage}}
                </div>
              }

            </div>

          </div>

        </div>

      </div>

    </div>
    <ng-template app-confirm-simple>
      <app-confirm-modal-component></app-confirm-modal-component>
    </ng-template>
  </div>
